// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"70af910c","453":"b4c5826b","626":"83666f32"}[chunkId] + ".chunk.js";
};